import { toast } from "sonner"

export function noPermissionToast(msg?: string) {
  toast.error(msg || "You don't have permission to do that.")
}
